module.exports = __webpack_public_path__ + "static/media/white-label1.97c1659d.jpg";